import React, { useEffect, useState } from "react";
import RecipeService from "services/RecipeService";
import { Table, Spinner } from "react-bootstrap";
import { format } from "date-fns";
import { ERROR_FETCHING_SHARED_RECIPES } from "configurations/MessageConstants";
import EmptyShare from "components/common/EmptyShare";

const SharedRecipeDetails = ({ recipe }) => {
  const [sharedDetails, setSharedDetails] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const getSharedRecipes = async () => {
      try {
        setIsLoading(true);
        const response = await RecipeService.getSharedRecipes(recipe.id);
        setSharedDetails(response.items);
      } catch (error) {
        console.error(ERROR_FETCHING_SHARED_RECIPES, error);
      } finally {
        setIsLoading(false);
      }
    };
    getSharedRecipes();
  }, [recipe]);

  const formatDate = (dateString) => {
    return format(new Date(dateString), "MM/dd/yyyy");
  };

  return (
    <div className="d-flex flex-column gap-2">
      {isLoading ? (
        <div className="loader-container">
          <Spinner animation="border" variant="dark" size="lg" />
        </div>
      ) : sharedDetails.length === 0 ? (
        <div className="text-center text-muted">
          <EmptyShare
            emptyText={
              <>
                <b>{recipe.name}</b> is not shared with any user.
              </>
            }
          />
        </div>
      ) : (
        <div>
          <h6 className="my-3 text-muted text-start">
            <b>{recipe.name}</b> has been shared with:
          </h6>
          <Table
            bordered
            hover
            responsive
            className="share-container text-nowrap text-center"
          >
            <thead>
              <tr>
                <th>Name</th>
                <th>Username</th>
                <th>Info</th>
              </tr>
            </thead>
            <tbody>
              {sharedDetails.map((user) => (
                <tr key={user.id} className="small">
                  <td>{user.userName}</td>
                  <td>{user.userEmail}</td>

                  <td className="text-center">
                    Shared on {formatDate(user.created)}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
    </div>
  );
};

export default SharedRecipeDetails;
